import register from '../../../../global/js/registry';
export default register('o-finder', () => import(/* webpackMode: "lazy" */ './o-finder.controller'));
